import { Box, Flex } from "@chakra-ui/react";
import LoginForm from "./components/loginForm";
import { useCookies } from "react-cookie";
import Bowser from "bowser";
import { useEffect } from "react";

function Login() {
  const [cookies, setCookie, removeCookie] = useCookies(["bg"]);

  const browser = Bowser.getParser(window.navigator.userAgent);
  // console.log("browser", browser);

  const isUnsupported = browser.satisfies({
    chrome: ">100",
    edge: ">100",
    firefox: ">80",
    safari: ">14",
  });

  useEffect(() => {
    const isWindows10OrHigher = () => {
      const userAgent = window.navigator.userAgent;
      return (
        /Windows NT 10/.test(userAgent) || /Windows NT [1][1-9]/.test(userAgent)
      );
    };

    if (!isUnsupported && isWindows10OrHigher()) {
      console.log("Browser não suportado");
      console.log("Versão do navegador: ", browser.getBrowserVersion());
    } else {
      console.log("Browser suportado");
    }
  }, []);

  return (
    <Flex w={"100vw"} h={"100vh"}>
      <Box w={"100%"} h="100%" shadow={"md"} bgColor={"#F1F1F1"}>
        <Flex
          w="100%"
          h="100%"
          justifyContent={"center"}
          alignItems={"center"}
          bgImage={
            cookies.bg && cookies.bg !== null
              ? cookies.bg
              : "/images/loginCliente.jpg"
          }
          bgSize={"cover"}
        >
          <Box
            bgColor={"#ffffff40"}
            w={"25%"}
            h={"50%"}
            borderRadius={"20px"}
            border={"4px solid #ffffff50"}
            filter={"blur"}
            backdropFilter={"auto"}
          >
            <LoginForm />
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
}
export default Login;
